import {
  Document,
  Page,
  Image as PDFImage,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import React from "react";
import DocMobileLogo from "../../assets/images/DocMobilLogo.png";

const styles = StyleSheet.create({
  page: {
    padding: 40,
    position: "relative",
    fontFamily: "Helvetica",
    minHeight: "100%",
  },
  watermarkContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    opacity: 0.3,
    zIndex: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  watermarkImage: {
    width: 200,
    height: 200,
    objectFit: "contain",
  },
  content: {
    position: "relative",
    zIndex: 1,
  },
  heading: {
    fontSize: 22,
    fontWeight: 700,
    marginBottom: 16,
  },
});

const GenericPDFDocument = ({ heading, children }) => (
  <Document>
    <Page size="A4" style={styles.page} wrap>
      <View style={styles.watermarkContainer} fixed>
        <PDFImage src={DocMobileLogo} style={styles.watermarkImage} />
      </View>
      <View style={styles.content}>
        <Text style={styles.heading}>{heading}</Text>
        {children}
      </View>
    </Page>
  </Document>
);

export default GenericPDFDocument;
